//listen to certain acttions and do something when they occur
import { all, takeLatest } from "redux-saga/effects";
import * as ActionTypes from "../Actions/ActionTypes";
import { activateLoader } from "../Actions/utils";
import { FetchingUserInfo } from "./utils";

export function* watchAuth() {
  //setting a listener to this action and then execute saga
  yield all([takeLatest(ActionTypes.IS_AUTH_SAGA, FetchingUserInfo)]);
}
